import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './slice/cartSlice'

export const store = configureStore({
reducer:{
    carts:cartReducer
},
devTools:true
})